export default __webpack_public_path__ + "static/media/sticker-H.cb0dcefb.png";